import { api } from './api';

// GET all app configs (minimal info for table)
export const getAppConfigs = () => api.get('/admin/app-configs');

// GET full app config details
export const getAppConfigDetails = (id: number) => api.get(`/admin/app-config/${id}`);

// UPDATE app config (editable fields)
export const updateAppConfig = (id: number, data: any) => api.patch(`/admin/app-config/${id}`, data);

// OPTIONAL: DELETE an app config (if supported)
export const deleteAppConfig = (id: number) => api.delete(`/admin/app-config/${id}`);

// CREATE an app config
export const createAppConfig = (data: any) => api.post('/admin/app-config', data);
